import { isUtenteSpeciale } from "../../modificaProdotti/permessiProdotto";
import useApriProdottoSolaLettura from "../../modificaProdotti/useApriProdottoSolaLettura";
import React, { useState, useEffect } from 'react';
import apiUrl from '../../Apiurl';
import prodVuoto from '../../prodottoVuoto';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';

function CodiceVSVoceCliccabile3({
  codVS,
  codPS,
  codProd,
  shortName,
  setProductFunction,
  utente,
  tit,
  imm
}) {

  const { apriProdotto, errore } = useApriProdottoSolaLettura();

  const { user, /* isAuthenticated,  */getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");

  const data = {
    codiceVS: codVS,
    codicePS: codPS,
    codiceProduttore: codProd,
    shortName: shortName,
    tit: tit,
    imm: imm
  }

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };
    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);


  const handleSubmit = (e) => {
    if (isUtenteSpeciale(utente)) {
      e.preventDefault();
      apriProdotto(codVS, (data) => setProductFunction(data[0]));
      return;
    }
    if (!token) {
      console.warn("sto aspettando un token")
      return;
    }
    if (utente.permessiAPI["update:database"]) {

      const config = {
        headers: {
          'Authorization': 'Bearer ' + token,
        },
      }
      axios.post(apiUrl + "/prodotti/prodotto/showORcreateIDPS3", data, config)
        .then(data => setProductFunction(data.data[0] || prodVuoto))
        .then(e.preventDefault())
    }
  }


  return (
    <>
      <span className="pointer" onClick={handleSubmit}>
        <strong>{codVS}</strong>
      </span>
      {errore && <span role="alert">{errore}</span>}
    </>
  )
}


export default CodiceVSVoceCliccabile3;



